import Helper from '@ember/component/helper';
import { service } from '@ember/service';

export default class PermissionsBase extends Helper {
  @service
  session;

  @service
  permissions;

  compute() {
    return false;
  }
}
